<template>
  <NavMenu />
  <div class="app-wrapper">
    <router-view />
    <Footer />
  </div>
  <Loader v-show="loading" />
</template>

<script>
import NavMenu from "@/components/NavMenu.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";
import { emitter } from '@/services/emitter.service';

export default {
  components: {
    NavMenu,
    Footer,
    Loader
  },
  data() {
    return { loading: false };
  },
  created() {
    emitter.on("showLoader", (e) => {
      this.loading = e;
    });
  }
};
</script>